import axios from "axios";
import router from "@/routes/router";

// export const BASE_URL = "https://staging.telegramtools.io/api"; // staging
// export const BASE_URL = "https://2h3wh.telegramtools.io/api"; // previous ParsPack
export const BASE_URL =
  process.env.VUE_APP_API_URL || "https://crm-api.dctm.dev/api";

// Authorization key
export let authorizationKey = localStorage.getItem("authToken")
  ? `Bearer ${localStorage.getItem("authToken")}`
  : null;

export const setAuthKey = (key) => {
  authorizationKey = `Bearer ${key}`;
};

// Create Axios instance
export const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Content-Type, Authorization",
  },
});

// Track all active `AbortController` instances
const activeControllers = [];

// Helper to remove a controller from the active list
const removeController = (signal) => {
  const index = activeControllers.findIndex(
    (controller) => controller.signal === signal,
  );
  if (index !== -1) {
    activeControllers.splice(index, 1); // Remove the controller
  }
};

// Add a request interceptor
api.interceptors.request.use((config) => {
  // Create a new AbortController for each request
  const controller = new AbortController();
  config.signal = controller.signal;

  // Add the controller to the active controllers list
  activeControllers.push(controller);

  // Add the Authorization key to headers
  if (authorizationKey) {
    config.headers.Authorization = authorizationKey;
  }

  return config;
});

// Add a response interceptor
api.interceptors.response.use(
  (response) => {
    // Clean up the controller after the request completes
    removeController(response.config.signal);
    return response;
  },
  (error) => {
    // Handle 401 errors (unauthorized)
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized: Redirecting to login page...");
      router.push("/login");
      localStorage.removeItem("authToken");
    }

    // Clean up the controller even if there's an error
    if (error.config && error.config.signal) {
      removeController(error.config.signal);
    }

    return Promise.reject(error);
  },
);

// Abort all active requests
export const abortAllRequests = () => {
  activeControllers.forEach((controller) => controller.abort());
  activeControllers.length = 0; // Clear the array
};
